<template>
  <div class="gl_filter">
    <el-form label-width="90px">
      <el-form-item label='会计期间：'>
        <accounting-period @defaultTime="getPeriod" :isDaterange='true'></accounting-period>
      </el-form-item>
      <el-form-item label='起始科目：'>
        <el-select v-model="startId" placeholder="请选择" size="small" filterable @change = "handleChange">
          <el-option
            v-for="item in subjectList_s"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label='结束科目：'>
        <el-select v-model="endId" placeholder="请选择" size="small" filterable >
          <el-option
            v-for="item in subjectList_e"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label='科目级别：'>
        <el-select v-model="form.startLevel" placeholder="请选择" size="small" style="width:140px" >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <span class="center_gap">至</span>
        <el-select v-model="form.endLevel" placeholder="请选择" size="small" style="width:140px">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label='币别：'>
        <el-select v-model="form.currencyId" placeholder="请选择" size="small" style="width:140px">
          <el-option
            v-for="item in currencyList"
            :key="item.id"
            :label="item.name"
            :value="item.id">  
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <!-- check -->
    <div class="gl_filter__footer">
         <el-checkbox v-model="form.includeItem" :true-label="1" :false-label = "0">显示辅助核算</el-checkbox>
         <el-checkbox v-model="form.onlyBalance" :true-label="1" :false-label = "0">余额为 0 不显示</el-checkbox>
         <el-checkbox v-model="form.balabceAndCreditOrDebit" :true-label="1" :false-label = "0">无发生额且余额为0不显示</el-checkbox>
         <el-checkbox v-model="form.noArise" :true-label="1" :false-label = "0">无发生额不显示本期合计、本年累计</el-checkbox>
    </div>
    <!-- btn -->
    <div class="gl_filter__btn center mt30">
        <accBtn type="2" text="取消" @click="$emit('close')" width="80px" />
        <accBtn @click="reset" type="3" text="重置" width="80px" />
        <accBtn @click="confirm" />
    </div>
  </div>
</template>
<script>
import accountingPeriod from '@/components/dialog/accountingPeriod'
import { getForeignCurrency, getAllSujectByContent } from "@/api"
export default {
  props: {

  },
  components: {accountingPeriod},
  data() {
    return {
      currencyList:[],
      subjectList:[],
      subjectList_s:[],
      subjectList_e:[],
      startId:"",
      endId: "",
      options: [{
					value: 1,
					label: '一级'
				},{
					value: 2,
					label: '二级'
				},{
					value: 3,
					label: '三级'
				},{
					value: 4,
					label: '四级'
				},{
					value: 5,
					label: '五级'
				}],
        value: '',
        checked: false,
        form: {
          startSubjectId:"",
          endSubjectId: "",
          start: "",
          end: "",
          startLevel: "",
          endLevel: "",
          currencyId: "", // 币别 综合本位币 不传
          includeItem: 0, // 显示辅助核算
          onlyBalance: 0, // 余额为0不显示
          balabceAndCreditOrDebit: 0, // 无发生额且余额为0不显示
          noArise: 0, // 无发生额不显示本期合计、本年累计
        }
    }
  },
  created() { 
    this._getForeignCurrency();
    this._getAllSujectByContent();
  },
  methods: {
    reset() { // 重置
      this.startId = ""
      this.endId =  ""
      this.subjectList_e =  JSON.parse(JSON.stringify(this.subjectList));
      this.form = {
          startLevel: "",
          endLevel: "",
          currencyId: "", // 币别 综合本位币 不传
          includeItem: 0, // 显示辅助核算
          onlyBalance: 0, // 余额为0不显示
          balabceAndCreditOrDebit: 0, // 无发生额且余额为0不显示
          noArise: 0, // 无发生额不显示本期合计、本年累计
          startSubjectId:"",
          endSubjectId: "",
        }
        this.$emit('getForm',this.form)
    },
    confirm() {  // 提交
      if(this.form.startLevel > this.form.endLevel) return this.$message.warning("科目类别结尾不能比开始小");
      let subjectIds = [];
      this.subjectIds = [] // 重置开始结束id
      if(this.startId && !this.endId) { // 有开始没有结束
        const startIndex = this.subjectList.findIndex(i=> i.id === this.startId);
        subjectIds = this.subjectList.slice(startIndex).map(i=> i.id)
      }
      if(!this.startId && this.endId) { // 没有开始有结束
        const endIndex = this.subjectList.findIndex(i=> i.id === this.endId);
        subjectIds = this.subjectList.slice(0,endIndex+1).map(i=> i.id)
      }
      if(this.startId && this.endId) { // 开始结束都有
        const startIndex = this.subjectList.findIndex(i=> i.id === this.startId);
        const endIndex = this.subjectList.findIndex(i=> i.id === this.endId);
        subjectIds = this.subjectList.slice(startIndex,endIndex+1).map(i=> i.id)
      }
      if(this.startId || this.endId) {
         this.form.startSubjectId = subjectIds[0]
         this.form.endSubjectId = subjectIds[subjectIds.length-1]
      }
     
      this.$emit('getForm',this.form)
    },
    handleChange(val) {
      const _index = this.subjectList.findIndex(i=> i.id === val)
        if(this.endId) {
          const endIndex = this.subjectList.findIndex(i=> i.id === this.endId);
          if(endIndex < _index) {
            this.endId = "";
          }
        }
      this.subjectList_e = this.subjectList.slice(_index);
    },
    async _getAllSujectByContent() {
      const { data } = await getAllSujectByContent();
      if(data.code == 1) {
        let list = data.data.map(i=> {
          i.name = i.code + "_" + i.name
          return i
        })
        this.subjectList = JSON.parse(JSON.stringify(list));
        this.subjectList_s = JSON.parse(JSON.stringify(list));
        this.subjectList_e = JSON.parse(JSON.stringify(list));
      }
    },
    async _getForeignCurrency() {
      const { data } = await getForeignCurrency();
      this.currencyList = [];
      if(data.code == 1) {
        this.currencyList = data.data;
        this.currencyList.unshift({
          name:"综合本位币",
          id: ""
        })
      }
    },
    getPeriod(data) {
      this.form = Object.assign(this.form,{
				start: this.$util.formatDate.format(data.yearPeriodsStart, 'yyyyMM'),
				end: this.$util.formatDate.format(data.yearPeriodsEnd, 'yyyyMM'),
			});
      this.$emit('getPeriod',{ start: this.form.start, end: this.form.end,  })
    }
  }
}
</script>
<style lang="less" scoped>
.gl_filter {
  background: #FFFFFF;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12);
  border-radius: 4px;
  padding: 20px;
  position: absolute;
  z-index: 999;
  left: 0;
  top: 40px;
  &__footer {
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px solid #EEEEEE;
    /deep/.el-checkbox {
      margin-bottom: 15px;
      display: block;
    }
  }
  .center_gap {
    margin: 0 5px;
  }
  /deep/.el-form-item {
    margin-bottom: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/accountBook/com/gl_filter.vue